import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18Contentsbox1 = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M14.941 4.5a.79.79 0 0 1 .79.79v7.88a2.14 2.14 0 0 1-2.13 2.14h-9.42a2.14 2.14 0 0 1-2.14-2.14V5.3a.79.79 0 0 1 .432-.704l.041-.018.079-.078Zm-.41 1.199H3.241v7.471c0 .482.363.88.83.934l.11.006h9.417a.94.94 0 0 0 .933-.94zM9.881 7.82a.6.6 0 0 1 .098 1.192l-.098.008h-1.98a.6.6 0 0 1-.097-1.192l.097-.008zm2.57-5.92a.6.6 0 0 1 .098 1.192l-.098.008h-7.12a.6.6 0 0 1-.097-1.192l.097-.008z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18Contentsbox1$1 = Svg18Contentsbox1;

export { Svg18Contentsbox1$1 as default };
